import { CloseOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, InputNumber, Row, Typography } from 'antd';
import type { FC } from 'react';

import './style.scss';

const { Text } = Typography;

export interface LegendSettingsFormItemsProps {
  formItemName: number;
  onCloseClick?(): void;
}

export const LegendSettingsFormItems: FC<LegendSettingsFormItemsProps> = ({
  formItemName,
  onCloseClick,
}) => {
  return (
    <div className="cartogram-legends__settings">
      <Row gutter={[8, 0]} align="middle">
        <Col span={6}>
          <Text>Диапазон</Text>
        </Col>
        <Col span={18}>
          <div className="cartogram-legends__settings__range">
            <Form.Item
              style={{ width: '100%' }}
              name={[formItemName, 'minValue']}
              className="cartogram-legends__settings__item"
              label="значение"
              labelCol={{ hidden: true }}
              rules={[{ required: true }]}
            >
              <InputNumber style={{ width: '100%' }} min={0} />
            </Form.Item>

            <Form.Item
              style={{ width: '100%' }}
              name={[formItemName, 'maxValue']}
              className="cartogram-legends__settings__item"
              label="значение"
              labelCol={{ hidden: true }}
              rules={[{ required: true }]}
            >
              <InputNumber style={{ width: '100%' }} min={0} />
            </Form.Item>
          </div>
        </Col>
      </Row>

      <Row gutter={[8, 0]} align="middle">
        <Col span={6}>
          <Text>Описание</Text>
        </Col>
        <Col span={18}>
          <Form.Item
            name={[formItemName, 'description']}
            className="cartogram-legends__settings__item"
            label="описание"
            labelCol={{ hidden: true }}
            rules={[{ required: true }]}
          >
            <Input placeholder="Введите описание" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[8, 0]} align="middle">
        <Col span={6}>
          <Text>Цвет</Text>
        </Col>
        <Col span={18}>
          <Form.Item
            name={[formItemName, 'color']}
            className="cartogram-legends__settings__item"
            label="цвет"
            labelCol={{ hidden: true }}
            rules={[{ required: true }]}
          >
            <Input type="color" placeholder="Выберите цвет" />
          </Form.Item>
        </Col>
      </Row>

      <Button
        onClick={onCloseClick}
        type="text"
        className="cartogram-legends__settings__close-button"
        icon={<CloseOutlined />}
      />
    </div>
  );
};
